export default __webpack_public_path__ + "static/media/2007.50910bb9.webp";